var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"memod-footer"},[_c('span',[_vm._v("© "+_vm._s(_vm.currentYear)+" Memo'd Technologies, LLC. Contact us at "),_c('a',{attrs:{"href":"mailto:beta@memod.com"}},[_vm._v("beta@memod.com")])])])}
var staticRenderFns = []

export { render, staticRenderFns }